var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"full-height"},[_c('guide-book-paper-place-of-sale',{attrs:{"guide-book-paper":_vm.guideBookPaper}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }